export const ORDER_SOURCE_DSP = 'DSP'
export const ORDER_SOURCE_DBP = 'DBP'

export const isDspSource = (source) =>
  String(source || '').toUpperCase() === ORDER_SOURCE_DSP

export const isDbpSource = (source) =>
  String(source || '').toUpperCase() === ORDER_SOURCE_DBP

/**
 * `source` reaches us as the raw order_details value and is matched against, filtered
 * on, and used to pick a route, so the stored value has to stay 'DSP'. Only the word
 * shown to users changes.
 */
const ORDER_SOURCE_LABELS = {
  [ORDER_SOURCE_DSP]: 'B2C',
}

export const getOrderSourceLabel = (source) =>
  ORDER_SOURCE_LABELS[String(source || '').toUpperCase()] || source || ''
